
// src/services/adminAuth.js
import { post } from '../../services/api';

const BASE = '/admin';

export const loginAdmin = async (email, password) => {
  const res = await post(`${BASE}/login`, { email, password });
  return res.data;
};

export const logoutAdmin = async () => {
  const token = localStorage.getItem('token');
  const res = await post(`${BASE}/logout`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
